import React from 'react'
import { useSelector } from 'react-redux'
import Typography from 'src/lib/ui/Typography'
import Page from 'src/components/Page'
import styles from 'src/features/static/Static.module.sass'
import cx from 'classnames'
import { getConfig } from 'src/features/config/ConfigSelector'
import SpinnerPage from 'src/components/SpinnerPage'

const NotFoundPage = () => {
  // Get dynamic pages config
  const pagesConfig = useSelector(getConfig('pages'))

  return (
    <>
      {/* Validation to avoid showing 404 when dynamic pages are loading */}
      {pagesConfig ? (
        <Page className={cx(styles.static, styles.centered)}>
          <Typography type="headline" gutterBottom>
            Not found
          </Typography>
          <Typography type="subheading">
            We can't seem to find the page you are looking for.
          </Typography>
        </Page>
      ) : (
        <SpinnerPage />
      )}
    </>
  )
}

export default NotFoundPage
